import { get } from 'lodash-es';
import { logger } from 'client/utils/logger/logger';
import { CaramelApi } from 'client/data/api/api-client';
import { ClientConfig } from 'client/configuration';

function getCaramelCreateDealAPIPayload({ dealer, vinData }) {
  return {
    vehicle: {
      year: get(vinData, 'vehicleInfo.styleInfo.year'),
      make: get(vinData, 'vehicleInfo.styleInfo.make'),
      model: get(vinData, 'vehicleInfo.styleInfo.model'),
      mileage: get(vinData, 'vehicleInfo.mileage'),
      vin: get(vinData, 'vin'),
      askingPrice: get(vinData, 'prices.advertisedPrice'),
    },
    seller: {
      email: get(dealer, 'dealerContactEmail'),
      firstName: get(dealer, 'dealerContactFirstName'),
      lastName: get(dealer, 'dealerContactLastName'),
      zipCode: get(dealer, 'dealerZipCode'),
      phoneNum: get(dealer, 'dealerPhone'),
      registrationState: get(vinData, 'dealerInfo.address.stateCode'),
      externalUserId: get(dealer, 'franchiseId', '').toString(),
    },
    offerType: 'EdmundsFixedOffer',
    ...(dealer?.existingDealId && { dealId: dealer?.dealId }),
  };
}

export async function createDeal(data) {
  const options = {
    method: 'POST',
    retries: 0,
    headers: {
      'content-type': 'application/json',
    },
    timeout: ClientConfig.get('carBuying').apiDefaultTimeoutMs,
  };

  try {
    const { protocol, hostName } = data;
    const caramelApiUrl = ClientConfig.get('caramelApiUrl');
    const url = /^(https:\/\/)/.test(caramelApiUrl) ? caramelApiUrl : `${protocol}://${hostName}${caramelApiUrl}`;
    const response = await CaramelApi(url).fetchJson('/create-deal', {
      ...options,
      body: JSON.stringify(getCaramelCreateDealAPIPayload(data)),
    });

    return response;
  } catch (e) {
    logger.error(`Caramel create deal API error`);
    return e;
  }
}
